export const actionTypes = {
    ANNOTATION_GET_ACTIVE_STRING: 'ANNOTATION/GET_ACTIVE_STRING',
    REPLYING_TO_COMMENT: 'ANNOTATION/REPLYING_TO_COMMENT',
    ANNOTATION_UPDATE_ALL: 'ANNOTATION/UPDATE_ALL',
    ANNOTATION_COMMENT_ID: 'ANNOTATION/COMMENT_ID',
    ANNOTATION_RESET_ALL: 'ANNOTATION/RESET_ALL',
    SOCIAL_EDITING_COMMENT: 'SOCIAL/EDITING_COMMENT',
    COMMENT_SET: 'COMMENT/SET',
};
